const COINS_KEY = 'neuro_duel_coins';
const GEMS_KEY = 'neuro_duel_gems';

class WalletManager {
  private coins = 0;
  private gems = 0;

  constructor() {
    this.load();
  }

  private load() {
    try {
      const raw = localStorage.getItem(COINS_KEY);
      if (raw !== null) {
        this.coins = parseInt(raw, 10) || 0;
        this.gems = parseInt(localStorage.getItem(GEMS_KEY) || '0', 10) || 0;
      } else {
        // 新玩家赠送初始金币和宝石
        this.coins = 500;
        this.gems = 5;
        this.save();
      }
    } catch {
      this.coins = 500;
      this.gems = 5;
    }
  }

  private save() {
    try {
      localStorage.setItem(COINS_KEY, String(this.coins));
      localStorage.setItem(GEMS_KEY, String(this.gems));
    } catch {}
  }

  getCoins(): number { return this.coins; }
  getGems(): number { return this.gems; }

  addCoins(amount: number) {
    this.coins = Math.max(0, this.coins + amount);
    this.save();
  }

  addGems(amount: number) {
    this.gems = Math.max(0, this.gems + amount);
    this.save();
  }

  spendCoins(amount: number): boolean {
    if (this.coins < amount) return false;
    this.coins -= amount;
    this.save();
    return true;
  }

  spendGems(amount: number): boolean {
    if (this.gems < amount) return false;
    this.gems -= amount;
    this.save();
    return true;
  }

  earnFromBattle(won: boolean, score: number, combo: number) {
    let coins = Math.floor(score / 10);
    if (won) coins += 100;
    if (combo >= 10) coins += 50;
    if (combo >= 20) coins += 100;
    this.addCoins(coins);

    let gems = 0;
    if (won) gems = 1;
    if (score >= 80) gems += 1;
    if (combo >= 20) gems += 1;
    if (gems > 0) this.addGems(gems);
  }

  reset() {
    this.coins = 0;
    this.gems = 0;
    this.save();
  }
}

export const walletManager = new WalletManager();
